<div class="bg-whit">
  <div class="bg-white">
    <div class="border-bottom row mx-0 p-3">
      <div class="col-12 col-sm-6 d-flex align-items-center pt-2">
        <h4>
          <span *ngIf="isUpdate">{{ 'Sellers.Products.Edit' | translate }}</span>
          <span *ngIf="!isUpdate">{{ 'Sellers.Products.Add' | translate }}</span>
          {{ 'Sellers.Products.Product' | translate }}
        </h4>
      </div>
      <div class="col-12 col-sm-6" *ngIf="currentStep == 1">
        <div class="form-group" *ngIf="!isUpdate">
          <div class="input-group">
            <div class="form-text me-3 pt-1">
              {{ 'Sellers.Products.CopyFromProduct' | translate }}
            </div>
            <select class="form-control form-select" placeholder="{{ 'Sellers.Products.SelectProduct' | translate }}"
              (change)="onProductSelection($event)">
              <option *ngIf="noSelected"></option>
              <option *ngFor="let product of similarProducts" [value]="product.id">{{ product.productName }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
    <div class="col-12 col-md-3 d-md-block">
      <div class="row mx-0 justify-content-center couterlist">
        <a class="col-md-12 add-step" [ngClass]="currentStep === 1 ? 'primarybock': 'text-muted'" (click)="goToStep(1)" >
          <div class="text-center">

            <span class="numberleft">1</span>
            <img alt="" height="50" width="50" class="img-fluid"
                 src="{{currentStep === 1 ? listCurrentIcon: listIcon}}" />
            <div class="" [ngClass]="currentStep === 1 ? 'text-primary': 'text-muted'">
               {{ 'Sellers.Products.BasicInfo' | translate }}
            </div>
          </div>
        </a>
        <a class="col-md-12 add-step" [ngClass]="currentStep === 2 ? 'primarybock': 'text-muted'" (click)="goToStep(2)">
          <div class="text-center">
            <span class="numberleft">2</span>
            <img alt="" height="50" width="50" class="img-fluid"
                 src="{{currentStep === 2 ? responsiveCurrentIcon: responsiveIcon}}" />
            <div class="" [ngClass]="currentStep === 2 ? 'text-primary': 'text-muted'">
               {{ 'Sellers.Products.ExtraInfo' | translate }}
            </div>
          </div>
        </a>

        <a class="col-md-12 add-step" [ngClass]="currentStep === 3? 'primarybock': 'text-muted'" (click)="goToStep(3)">
          <div class="text-center">
            <span class="numberleft">3</span>
            <img alt="" height="50" width="50" class="img-fluid"
                 src="{{currentStep === 3 ? listCurrentIcon: listIcon}}" />
            <div class="" [ngClass]="currentStep ===3 ? 'text-primary': 'text-muted'">
               {{ 'Sellers.Products.BuyersInformation' | translate }}
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="col-12 col-md-9 p-3 pb-0 fs-6">
        <div [style.display]="currentStep == 1 ? 'block' : 'none'">
          <app-product-step-one></app-product-step-one>

        </div>
        <div [style.display]="currentStep == 2 ? 'block' : 'none'">
          <app-product-step-two></app-product-step-two>
        </div>
        <div [style.display]="currentStep == 3 ? 'block' : 'none'">
          <app-product-step-three *ngIf="(isUpdate || productIsCopied) && productObject" [productObject]="productObject"></app-product-step-three>
          <app-product-step-three *ngIf="!productObject"></app-product-step-three>
        </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3 p-3 d-none d-md-block"></div>
    <div class="col-sm-9 mx-0 p-3 pt-0">
      <div class="row justify-content-between btncleardes">
        <div class="col-auto">
          <div class="btn btn-grey text-uppercase" *ngIf="currentStep !== 1" (click)="navigateToStep('prev')">
            {{ 'Sellers.Products.Previous' | translate }}
          </div>
        </div>
        <div class="col-auto">
          <button [disabled]="isSubmitting || !isBuyerInfoFormValid" class="btn btn-primary text-uppercase" type="button" (click)="submit()" *ngIf="currentStep === 3">
            {{ 'Sellers.Products.Submit' | translate }}
          </button>
          <div class="btn btn-success text-uppercase" (click)="navigateToStep('next')" *ngIf="currentStep !== 3" >
            {{ 'Sellers.Products.SaveContinue' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
